import React from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const NationalPark = () => {
  const parks = [
    {
      "S.no": 1,
      Name: "Arches National Park",
      "County Name": "Grand",
      Address: "PO Box 907, Moab, UT 84532",
      Website: "https://www.nps.gov/arch/index.htm",
      "Contact No": "435-719-2299",
      link: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/arches",
    },
    {
      "S.no": 2,
      Name: "Bryce Canyon National Park",
      "County Name": "Garfield and Kane",
      Address: "Highway 63, Bryce, UT 84764",
      Website: "https://www.nps.gov/brca/index.htm",
      "Contact No": "435-834-5322",
      link: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/bryce-canyon",
    },
    {
      "S.no": 3,
      Name: "Canyonlands National Park",
      "County Name": "San Juan, Wayne, Garfield, and Grand",
      Address: "2282 Southwest Resource Boulevard, Moab, UT 84532",
      Website: "https://www.nps.gov/cany/index.htm",
      "Contact No": "435-719-2313",
      link: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/canyonland",
    },
    {
      "S.no": 4,
      Name: "Capitol Reef National Park",
      "County Name": "Wayne, Garfield, Sevier, and Emery",
      Address: "HC 70 Box 15, Torrey, UT 84775",
      Website: "https://www.nps.gov/care/index.htm",
      "Contact No": "435-425-3791",
      link: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/capitolreef",
    },
    {
      "S.no": 5,
      Name: "Zion National Park",
      "County Name": "Washington, Iron, and Kane",
      Address: "Springdale, UT 84767",
      Website: "https://www.nps.gov/zion/index.htm",
      "Contact No": "435-772-3256",
      link: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/zion",
    },
  ];
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{ imageName: "national-park-bg.webp", title: "National Parks" }}
      />

      {/* Main Content */}
      <div className=" mx-auto  py-12 w-full">
        {/* Intro Section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
            Utah's National Parks
          </h1>
          <p className="text-xl text-blue-700">
            Witness the world-famous beauty of Utah’s national parks
          </p>
        </div>

        {/* Parks Table */}
        <div className="flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                  <tr>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[25%]">
                      Name
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[25%]">
                      County Name
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[30%]">
                      Contact
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[20%]">
                      Website
                    </th>
                    {/* <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Established
                                        </th> */}
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {parks.map((park, index) => (
                    <tr
                      key={index}
                      className="hover:bg-blue-50 transition-colors"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <Link
                          to={park.link}
                          className="font-bold text-base text-blue-900"
                        >
                          {park.Name}
                        </Link>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {park["County Name"]}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {park["Contact No"]}
                        </div>
                        <div className="text-sm text-center font-bold text-blue-900">
                          {park.Address}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <a
                          href={park.Website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                        >
                          Visit Website
                        </a>
                      </td>
                      {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                                                {park["Established on"]}
                                            </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default NationalPark;
